import { useQuery, useQueryCache } from "react-query";
import { useHeaders } from "hooks/api";
import { CustomFrameResponse, getCustomFrameReq } from "api/customFrames";

export const useCustomFrame = (key: string, materialSpecId: number, adMaterialId?: number, cacheById = true) => {
    const headers = useHeaders();
    const cachedFrame = useQueryCache();
    // if the frame will always be the same for every matspec/admaterial, set cacheById to false
    const queryKey = cacheById ? ["customFrame", key, materialSpecId, adMaterialId] : ["customFrame", key];

    return useQuery(queryKey, () => {
        const frame = cachedFrame.getQueryData<CustomFrameResponse>(queryKey);

        if (frame) {
            return frame;
        }

        return getCustomFrameReq(headers, { key, materialSpecId, adMaterialId });
    });
};
